import { getRows } from '../../../components/form/DisabilityInput';
import type { Page } from '../../types';
import { type GradeValue, gradeValueToLabel } from '../../utils/csc';

const rows = getRows().map((row) => ({ name: row, label: gradeValueToLabel(row as GradeValue) }));
const columns = ['Total'];

const disability: Page[] = [
  {
    pageType: 'question',
    title: 'Disability',
    name: 'fair-and-open-ethnicity',
    hidePageTitle: true,
    description:
      'Please provide breakdown of total recruitment of individuals who declared they had a disability by grade',
    hideContinueButton: true,
    navigateToSummaryOnComplete: true,
    questions: [
      {
        questionType: 'inset',
        title: '',
        insetContent:
          'You reported <strong>${1}</strong> people recruited through fair and open competition.<br><br>' +
          'Please provide a breakdown of these people by their grade and their disability status.',
        insetVariables: {
          1: {
            type: 'previousAnswer',
            key: 'headline-fair-and-open',
          },
        },
        name: 'external-recruit-disability-inset',
        detailsContent: 'Disability inset',
        rules: {
          required: true,
        },
      },
      {
        questionType: 'disabilityInput',
        title: 'Breakdown',
        name: 'disability-input-details',
        detailsHeading: 'More information',
        detailsContent: 'If the grade does not align directly you can use the equivalent',
        rules: {
          required: true,
        },
        customValidation: {
          sumLessThanOrEqualToPreviousAnswer: 'headline-fair-and-open',
          fieldsLessThanOrEqual: rows.map((row) => ({
            fields: columns.map((column) => `${row.name}${column}`),
            answer: 'fair-and-open-grade-column',
            answerValue: row.name,
            errorPrefix: `The total of ${row.label} must equal`,
          })),
        },
      },
    ],
  },
];
export default disability;
